const BASE = (process.env.REACT_APP_API_URL || '') + '/api';

function getToken() {
  return sessionStorage.getItem('admin_token') || '';
}

function adminHeaders(extra = {}) {
  return { 'Content-Type': 'application/json', 'x-admin-token': getToken(), ...extra };
}

export const api = {
  get: (path) => fetch(BASE + path).then(r => r.json()),
  post: (path, body) => fetch(BASE + path, { method: 'POST', headers: adminHeaders(), body: JSON.stringify(body) }).then(r => r.json()),
  put: (path, body) => fetch(BASE + path, { method: 'PUT', headers: adminHeaders(), body: JSON.stringify(body) }).then(r => r.json()),
  delete: (path) => fetch(BASE + path, { method: 'DELETE', headers: { 'x-admin-token': getToken() } }).then(r => r.json()),
  postForm: (path, formData) => fetch(BASE + path, { method: 'POST', headers: { 'x-admin-token': getToken() }, body: formData }).then(r => r.json()),
  putForm: (path, formData) => fetch(BASE + path, { method: 'PUT', headers: { 'x-admin-token': getToken() }, body: formData }).then(r => r.json()),
};

export const LEVEL_COLORS = {
  'מתחיל': '#5A8A5A',
  'מתקדם': '#E67E22',
  'מקצועי': '#8B5E3C',
};

export const CATEGORY_EMOJIS = {
  'מניאטורות': '🏠',
  'צביעה לפי מספר': '🎨',
  'יצירות יהלומים': '💎',
  'מניאטורות מתכת': '⚙️',
  'בניה בקאפה': '🚢',
  'בניה בעץ': '🪵',
  'בניה בלגו': '🧱',
};
